import { Combobox } from "@marekl/adminer/components";
import { ROLE_LABEL } from "../../lib/i18n/roles";
import type { SystemRole } from "../../auth/queries";
import type { ID } from "../../lib/id";
import { useTeams, type Team } from "../../lib/queries/teams";
import { federationLabel, useFederations, type Federation } from "../../lib/queries/federations";

/** Who content is narrowed to; the server matches it (service/audience). */
export interface AudienceTargets {
  roles: SystemRole[];
  team_ids: ID[];
  federation_ids: ID[];
}

const ROLES = Object.keys(ROLE_LABEL) as SystemRole[];

export interface AudienceFieldsProps {
  value: AudienceTargets;
  onChange: (next: AudienceTargets) => void;
  /** Says what „some role AND some team" means for this kind of content. */
  hint: string;
}

/**
 * The three pickers an oznámení and a stránka are targeted with: roles,
 * then teams and federations. Values on one axis are alternatives; both
 * axes must match. Empty means everybody.
 */
export function AudienceFields({ value, onChange, hint }: AudienceFieldsProps) {
  const { data: teams = [] } = useTeams();
  const { data: federations = [] } = useFederations();
  return (
    <>
      <Combobox<SystemRole, SystemRole>
        multiple
        label="Role"
        placeholder="Všechny role"
        options={ROLES}
        getOptionLabel={(r) => ROLE_LABEL[r]}
        getOptionValue={(r) => r}
        getOptionKey={(r) => r}
        value={value.roles}
        onChange={(roles) => onChange({ ...value, roles })}
      />
      <Combobox<Team, ID>
        multiple
        label="Týmy"
        placeholder="Všechny týmy"
        options={teams}
        getOptionLabel={(t) => t.name}
        getOptionValue={(t) => t.id}
        getOptionKey={(t) => t.id}
        value={value.team_ids}
        onChange={(team_ids) => onChange({ ...value, team_ids })}
      />
      <Combobox<Federation, ID>
        multiple
        label="Federace"
        placeholder="Všechny federace"
        options={federations}
        getOptionLabel={(f) => federationLabel(f)}
        getOptionValue={(f) => f.id}
        getOptionKey={(f) => f.id}
        value={value.federation_ids}
        onChange={(federation_ids) => onChange({ ...value, federation_ids })}
        hint={hint}
      />
    </>
  );
}
